import PropTypes from 'prop-types';
import React, { useState } from 'react';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import { Alert, Button, Card, CardBody, Col, Container, Input, InputGroup, Row } from 'reactstrap';

const ForgotPasswordPage = ({ForgotPasswordFunction}) => {

    const [username, setUserName] = useState(undefined)
    const [error, setError] = useState(undefined)
    const [sending, setSending] = useState(false)
    const [completed, setCompleted] = useState(false)
    
    const send = (event) => {
        if (username) {
            event.preventDefault();
            event.stopPropagation();
            setSending(true)
            setCompleted(false)
            ForgotPasswordFunction(username)
            .then(res => {
                    if (res.response.error.description){
                        setError(res.response.error)
                    }else{
                        setCompleted(true)
                        setError(undefined)
                    }
                    setSending(false)
                    
            }).catch(e=> setSending(false))
        }
	}
		
	return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="5">
                <Card className="p-4">
                    <CardBody>
                        <img 
                            src={'/img/logo-login.png'} 
                            style={{ width: '97%', marginBottom: '30px'}}
                        />
                        <h5>Password Recovery</h5>
                        { error && <Alert color="danger">{error.description}</Alert> }
                        { completed && <Alert color="success">An email has been sent. Please check your inbox</Alert> }
                        {!completed && 
                        <div>
                        <p className="text-muted">Enter your username</p>
                        <InputGroup className="mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text">
                                    <i className="icon-user"></i>
                                </span>
                            </div>
                            <Input 
                                type="text" 
                                placeholder="Username"
                                autoComplete="On"
                                value={username}
                                disabled={false}
                                onKeyDown={() => {}}
                                onChange={(e)=>{setUserName(e.target.value)}}
                            />
                        </InputGroup>
                        <Row>
                            <Col xs="12">
                                <LaddaButton
                                    loading={sending}
                                    className="btn btn-ladda btn-primary"
                                    disabled={sending}
                                    disabled={!(username && username.length)}
                                    onClick={send}
                                    data-style={EXPAND_RIGHT}
                                >
                                    Send
                                </LaddaButton>
                            </Col>
                        </Row>
                        </div>
                        }
                    </CardBody>
                </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
}

ForgotPasswordPage.propTypes = {
    ForgotPasswordFunction: PropTypes.func
}


const ResetPasswordPage = ({ResetPasswordFunction}) => {
    const [loading, setLoading] = useState(false)
    const [newpassword, setnewPassword] = useState('')
    const [newpassword2, setnewPassword2] = useState('')
    const [error, setError] = useState(false)
    const [completed, setCompleted] = useState(false)
    const hash = window.location.hash
    const params = new URLSearchParams(hash)
    const resetToken = params.get('#/resetPassword?token')
    const username = params.get('username')

    const send = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setLoading(true)
        setCompleted(false)
        ResetPasswordFunction(username, newpassword, resetToken)
        .then(res => {
                if (res.response.Error.description){
                    setError(res.response.Error)
                }else{
                    setCompleted(true)
                    setError(undefined)
                }
                setLoading(false)
                
        }).catch(e => {console.log(e); setLoading(false)})
	}
    return(
    <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="5">
                <Card className="p-4">
                    <img 
                        src={'/img/logo-login.png'} 
                        style={{ width: '97%', marginBottom: '30px'}}
                    />
                    <h5>Password Recovery</h5>
                    <p>*Password must contain at least 8 characters</p>
                    {!completed ? <CardBody>
                        
                        {error && <Alert color="danger">{error.description}</Alert> }
                        <p className="text-muted">New password</p>
                        <InputGroup className="mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text">
                                    <i className="icon-lock"></i>
                                </span>
                            </div>
                            <Input 
                                type="password" 
                                placeholder="" 
                                disabled={loading}
                                value = {newpassword}
                                onChange={(e)=>setnewPassword(e.target.value)}
                            />
                            
                        </InputGroup>
                        <p className="text-muted">Confirm new password</p>
                        <InputGroup className="mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text">
                                    <i className="icon-lock"></i>
                                </span>
                            </div>
                            <Input 
                                type="password" 
                                placeholder="" 
                                disabled={loading} 
                                value = {newpassword2} 
                                onChange={(e)=> setnewPassword2(e.target.value)}
                            />
                        </InputGroup>
                        <Row>
                            <Col xs="12">
                                <LaddaButton
                                    loading={loading}
                                    className="btn btn-ladda btn-primary"
                                    disabled={loading || (newpassword != newpassword2) 
                                            || newpassword.length < 8
                                            || newpassword2.length < 8}
                                    onClick={send}
                                    data-style={EXPAND_RIGHT}
                                >
                                    Send
                                </LaddaButton>
                            </Col>
                        </Row>
                    </CardBody>
                    :
                    <CardBody>
                        <Row className="justify-content-center">
                            <Alert color="success">Password changed succesfully!</Alert>
                        </Row>
                        <Row className="justify-content-center">
                            <a href="#/login">
                                <Button color="link" className="px-0">Back to Log-in</Button>
                            </a>
                        </Row>
                    </CardBody>}
            </Card>
        </Col>
        </Row>
    </Container>
    </div>
    )
}

ResetPasswordPage.propTypes = {
    ResetPasswordFunction: PropTypes.func
}


export {
    ForgotPasswordPage,
    ResetPasswordPage
};

